// @core/api/endpoints/project/get_component.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ComponentResponse,
} from '../../../types/project';

const BASE_PATH = '/project';

/**
 * Get component
 * Retrieves component details including lead and item count.
 */
export async function GetComponent(
  project_id: string,
  component_id: string,
  options?: RequestOptions
): Promise<ComponentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/components/:component_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':component_id', encodeURIComponent(component_id));
  const requestOptions = options;
  return client.get<ComponentResponse>(requestPath, { ...requestOptions });
}
